var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8325 8.28159C10.8872 8.7249 10.5839 9.13175 10.1439 9.20617L3.45417 10.3276C3.00007 10.4038 2.57018 10.0974 2.49402 9.64334C2.41787 9.18924 2.72432 8.76017 3.17841 8.68402L7.99891 7.87455L0.952836 2.37567C0.590498 2.09289 0.525828 1.56853 0.808602 1.2062C1.09138 0.843858 1.61491 0.779289 1.97808 1.06196L8.93217 6.48906L8.3128 1.46711C8.2565 1.01057 8.58132 0.594345 9.03787 0.538039C9.49441 0.481732 9.91063 0.806561 9.96694 1.2631L10.8324 8.28076L10.8325 8.28159Z",
    fill: "#C60F0F",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphDownArrow);
export default __webpack_public_path__ + "static/media/graph_down_arrow.e9ade37c5e5793e964378cf4e6ac9109.svg";
export { ForwardRef as ReactComponent };